/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WellDoneResponse } from '../../models/well-done-response';

export interface ActivityWellDone$Params {
  id: number;
}

export function activityWellDone(http: HttpClient, rootUrl: string, params: ActivityWellDone$Params, context?: HttpContext): Observable<StrictHttpResponse<WellDoneResponse>> {
  const rb = new RequestBuilder(rootUrl, activityWellDone.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WellDoneResponse>;
    })
  );
}

activityWellDone.PATH = '/rest/activity/{id}/well-done';
